import { useQuery } from 'react-query'
import type { AxiosError } from 'axios'
import { getPaymentStatus } from '../api/paymentsApi'
import { FINAL_PAYMENT_STATUSES, type PaymentStatusResponse } from '../api/types'

export const PAYMENT_STATUS_QUERY_KEY = (uuid: string) => ['payment-status', uuid] as const

const POLL_INTERVAL_MS = 1000

/**
 * Поллит статус платежа раз в секунду до финального статуса.
 * На 404 (платёж не наш / не существует) ретраи отключены.
 */
export const usePaymentStatusQuery = (trackingUuid: string | undefined) => {
  return useQuery<PaymentStatusResponse, AxiosError>(
    PAYMENT_STATUS_QUERY_KEY(trackingUuid ?? ''),
    () => getPaymentStatus(trackingUuid as string),
    {
      enabled: !!trackingUuid,
      refetchInterval: (data) =>
        data && FINAL_PAYMENT_STATUSES.includes(data.status) ? false : POLL_INTERVAL_MS,
      refetchIntervalInBackground: true,
      retry: (failureCount, error) => {
        if (error?.response?.status === 404) return false
        return failureCount < 3
      },
    }
  )
}
